icing.watch('[data-hash-nav]',
    nav => {

        if (window.location.hash) {
            const tab = nav.querySelector(`[href="${window.location.hash}"]`);
            if (tab) {
                tab.click();
            }
        }

        nav.addEventListener('click', e => {
            const navLink = e.target.closest('[data-bs-toggle="tab"]');
            if (!navLink) {
                return;
            }
            const hash = navLink.getAttribute('href') ?? navLink.dataset.bsTarget;
            if (hash.startsWith('#')) {
                window.location.hash = hash;
            }
        });
    }
);
